module.exports = __webpack_public_path__ + "static/media/upArrow.eafa2566.svg";